import { Input } from "antd";

const sharedProps = {
  length: 6,
  formatter: (str) => str.replace(/[^\d]/g, ""),
  inputMode: "numeric",
  size: "large",
};

const OtpInput = ({ id = "otp", label = "One-time passcode", value, onChange, error, required = true }) => (
  <div>
    {label && (
      <label htmlFor={id} className="block text-sm font-medium text-textPrimary mb-1.5">
        {label}
        {required && <span className="text-statusRed ml-0.5">*</span>}
      </label>
    )}
    <Input.OTP
      id={id}
      value={value}
      onChange={onChange}
      status={error ? "error" : undefined}
      className="otp-full-width"
      {...sharedProps}
    />
    {error && <p className="mt-1 text-xs text-statusRed">{error}</p>}
  </div>
);

export default OtpInput;
